$("form[data-form-submit-preventdefault]").submit(function (e) {
    e.preventDefault();
});

$('form[data-form-submit-ajax-thank]').submit(function (e) {
    if (!$(this).valid()) {
        return;
    }
    else {

        var formElement = $(this);
        var thankElement = $(this).attr('data-form-submit-ajax-thank');
        var additionalElementSelector = $(this).attr('data-form-stack-related-element-class');

        if (thankElement.length) {
            $(formElement).hide();
            $("." + additionalElementSelector).hide();
            //$(thankElement).show();
            $(thankElement).attr("style", "display: block !important"); //we use this instead of .show in case of a !important such as d-none
        }

    }
});

$("form.form-jquery-validate, form.validate").validate({
    invalidHandler: function (event, validator) {
        if (validator.numberOfInvalids()) {
            //If there are any invalid fields then we need to reset recaptcha so that it fires again the next time the user tries to submit
            //TODO: A better solution here would programatically invoke grecaptcha.execute() after successful validation instead of constantly
            //resetting until the form is valid.
            grecaptcha.reset();
        }
    },
    errorPlacement: function (error, element) {
        //For checkboxs we want the error to go above the parent so that its not in between the checkbox and the label
        if (element.attr("type") == "checkbox") {
            error.insertBefore(element.parent());
        } else {
            error.insertBefore(element);
        }
    }
})

window.captchaCallback = function (token) {
    //This method is invoked by recaptcha in response to a successful challenge to the user, it indicates the form is ready to submit so we should submit the form
    //TODO: recaptcha doesn't support multiple forms on the same page and so it doesn't pass any IDs or anything to tell us what form we are submitting
    //In theory we should just do $("form").submit() but that is likely to catch other forms like the site search.  Since captcha only applies to formstack 
    //forms, and those forms always have this class, and those forms only appear one per page, this solution is good enough for now but if the form system 
    //is ever revisited this has room for improvement.
    $(".formstack-form-form").submit();
}

//unneccesary, browsers inherently do this (implicit submission)
//$("form[data-form-submit-onenter] input, form[data-form-submit-onenter] textarea").on('keypress', function (event) {
//    if (event.key === "Enter") {
//        $(this).submit();
//    }
//});

//submit form if the user uses the enter key
$('input[type=text], input[type=search], input[type=tel], input[type=email], input[type=password]').keypress(function (e) {
    if (e.which == 13) {
        $(this).closest("form").submit();
        return false;
    }
});

function filter() {
    var valThis = $('#txtSearchValue').val();
    $('.dropdown-select ul > li').each(function () {
        var text = $(this).text();
        (text.toLowerCase().indexOf(valThis.toLowerCase()) > -1) ? $(this).show() : $(this).hide();
    });
};

function markDropdownLabels(context, query) {
    var instance = new Mark(context);

    // Remove previous marked elements and mark the new keyword inside the context
    instance.unmark({
        done: function () {
            instance.mark(query);
        }
    });
};

$('[data-dropdown-search]').on('input', function () {
    var dropdownContainer = $(this).closest('.dropdown-container');
    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu');
    var noResultsItem = $(dropdownMenu).find('.dropdown-no-results');

    //display dropdown if hidden
    if (dropdownMenu.is(":hidden")) {
        dropdownContainer.find('.dropdown-toggle').dropdown('toggle');
    }

    var search = $(this).val().toLowerCase();

    if (!search) {
        dropdownMenu.find('.dropdown-item').show();
    }

    //highlight (using markjs, requires a vanilla JS node collection)
    markDropdownLabels($(dropdownMenu).find('label').get(), search);

    var foundResults = false;

    //show/hide
    dropdownMenu.find('label').each(function () {
        //var text = $(this).contents().filter(function () {
        //    return this.nodeType == Node.TEXT_NODE;
        //})[0].nodeValue.toLowerCase();

        var text = $(this).text().toLowerCase();

        var dropdownItem = $(this).closest('.dropdown-item');

        if (text.indexOf(search) > -1) {
            $(noResultsItem).hide();
            dropdownItem.show();
            foundResults = true;
        }
        else {
            dropdownItem.hide();
        }
    });

    if (!foundResults) {
        $(noResultsItem).find("span").text(String.format('"{0}"', $(this).val()));
        $(noResultsItem).show();
    }
});

function isCheckBased(inputElement) {
    switch ($(inputElement).attr('type')) {
        case 'checkbox':
        case 'radio':
            return true;
        default:
            return false;
    }
}

$('[data-form-clear-input-trigger]').on('click', function () {
    var sourceElementId = $(this).attr('data-form-clear-input-trigger')

    if (sourceElementId) {
        var sourceElement = $(sourceElementId);
        var inputs = $(sourceElement).find(':input');
        clearInputs(inputs);
    }
    else {
        var inputs = $(this).closest('form').find(':input');
        clearInputs(inputs);
    }

    $(this).closest("form").submit();
});

window.clearInputs = function clearInputs(inputElements) {
    $(inputElements).each(function (index) {
        if (isCheckBased($(this))) {
            if ($(this)[0].hasAttribute('data-form-default')) {
                $(this).prop('checked', true);
            }
            else {
                $(this).prop('checked', false);
            }
        }
        else {
            $(this).val('');
        }


    });
}

$('form').on('submit', function (event) {
    //close any dropdowns
    if ($(this).attr('data-form-submit-closebsdropdowns')) {
        closeAllBSDropdowns($(this));
    }
});

window.closeAllBSDropdowns = function closeAllBSDropdowns(target) {

    if (!target) {
        target = document;
    }

    var dropdownContainer = $(this).find('dropdown-container');

    $(dropdownContainer).dropdown('hide');
    $(dropdownContainer).removeClass("show");
    $(dropdownContainer).find('.dropdown-menu').removeClass("show");
    $(dropdownContainer).find('.dropdown-toggle').attr('aria-expanded', 'false');
}

$('form[data-form-submit-update-query-string]').on('submit', function (event) {
    console.debug("Form submitted");

    var attrVal = $(this).attr('data-form-submit-update-query-string');

    if (attrVal === 'behavior:filter') {
        //TODO this should be moved/controlled via a more business logic-specific attribute
        var searchPhraseInput = $(this).find('input[name=search_phrase]');
        var unifiedInput = $(this).find('input[name=unified]');
        var specialtyInput = $(this).find('input[name=specialty]');
        var locationNameInput = $(this).find('input[name=location_name]');

        // JK 2023-03-15:  Replaced specialty-specific filter clearing logic with more generic logic to also handle location name filters.
        /*
        if (specialtyInput.length && (!specialtyInput.val() || specialtyInput.val() !== searchPhraseInput.val())) {
            $(specialtyInput).val('');
            $(unifiedInput).val($(searchPhraseInput).val());
        }
        */

        var clearSpecialtyInput = specialtyInput.length &&
                                  (
                                      !specialtyInput.val() ||
                                      specialtyInput.val() !== searchPhraseInput.val()
                                  );
        var clearLocationNameInput = locationNameInput.length &&
                                     (
                                        !locationNameInput.val() ||
                                        locationNameInput.val() !== searchPhraseInput.val()
                                     );
        
        if (clearSpecialtyInput) {
            $(specialtyInput).val('');
        }
        if (clearLocationNameInput) {
            $(locationNameInput).val('');
        }
        if (
            clearSpecialtyInput &&
            clearLocationNameInput
        ) {
            $(unifiedInput).val($(searchPhraseInput).val());
        }

    }

    //serialize all inputs
    var serializedInput = serializeFormWithExclusions(this);
    var previousSerializedInput = $(this).attr('data-form-current-query');

    //if the form values have changed since the last known serialized input, reset hidden pagination field to page 1
    if ($(this).attr('data-form-current-query') !== serializedInput) {
        $(this).find('input[name=page]').val('1');
        serializedInput = serializeFormWithExclusions(this);
    }

    //update the query string
    changeQueryString(serializedInput);
});

window.removeQueryStringParam = function (queryString, key) {
    var params = new URLSearchParams(queryString);

    params.delete(key);

    return params.toString();
}

//TODO abstract this to a shared level
window.changeQueryString = function (queryString) {
    var newUrl = window.location.href.split(/[?#]/)[0] + "?" + queryString;
    window.history.pushState({ path: newUrl }, '', newUrl);
}

$(document).ready(function () {
    $('form[data-form-submit-update-query-string]').each(function () {
        //set the current query to an attribute
        var serializedInput = serializeFormWithExclusions(this);
        $(this).attr('data-form-current-query', serializedInput);
    });
});

function serializeFormWithExclusions(form) {
    return $(form).find(':input').not('[data-form-exclude]').serialize();
}

//updates the value of targeted form element with the value of the current input
$(document).on('change', '[data-form-update-input-selector]', function () {
    var targetElementSelector = $(this).attr('data-form-update-input-selector');
    var targetElement = $(targetElementSelector);
    var value = $(this).val();

    if (targetElement && targetElement.length) {
        var targetElementType = targetElement.get(0).nodeName;
        var targetInputType = "";

        //only covering types needed, this can be extended over time
        if (targetElementType === "INPUT") {
            targetInputType = targetElement.attr('type');
        }
        else if (targetElementType === "SELECT") {
            targetInputType = 'SELECT';
        }

        if (targetInputType && targetInputType.length) {
            if (targetInputType === "radio") {
                $(targetElementSelector).removeAttr("checked", true);
                $(targetElementSelector + '[value="' + value + '"]').attr("checked", true);
            }
            else if (targetInputType === "SELECT" || targetInputType === "hidden") {
                $(targetElementSelector).val(value);
            }
        }
    }

    $(this).closest("form").submit();
})

//auto submit form for any input with the given attribute
$(document).on('change', '[data-form-input-change-trigger]', function () {

    var dependencyAttributeValue = $(this).attr('data-form-input-change-dependency');

    //if the input has a change dependency attribute
    if (dependencyAttributeValue) {
        //get the targeted dependency element
        var dependencyElement = $(dependencyAttributeValue);

        //if the targeted dependency element has a value, submit
        if ($(dependencyElement).length && $(dependencyElement).val()) {
            $(this).closest("form").submit();
        }
    }
    else {
        $(this).closest("form").submit();
    }
});

//for use with radio buttons/checkboxes, trigger submit on change based on a common shared parent containing the required attribute
//must contain inputs with matching names
$(document).ready(function () {
    $('[data-form-input-change-trigger-group]').each(function () {
        var inputName = $(this).find('input').attr('name');

        $('input[name=' + inputName + ']').on("change", function () {
            $(this).closest("form").submit();
        });
    });
});

/* for usage with MVC's Ajax.BeginForm. Exposed as window properties in order for the functions to be called by the external Msft Ajax library */
//this is an extended version of the base mvc functionality that disables inputs
window.MVCAjaxFormOnBegin = function (formId) {

    var form = $('#' + formId);
    var updateElementId = $(form).attr('data-ajax-custom-update-element');
    var loadingElementTargetId = $(form).attr('data-ajax-custom-loading-element');

    $('#' + updateElementId).addClass("ajax-overlay");
    $('#' + loadingElementTargetId).show();

    $(form).find(':input').attr('disabled', true);

    $(form).find('.dropdown-toggle').dropdown('hide');
}

//TODO move and rename below to FaP specific file
window.MVCAjaxFormOnSuccess = function (formId, data) {
    console.debug("ajax form success");

    var form = $('#' + formId);
    var updateElementId = $(form).attr('data-ajax-custom-update-element');
    var loadingElementTargetId = $(form).attr('data-ajax-custom-loading-element');

    $(form).find(':input').removeAttr('disabled');
    $(form).find('.dropdown-toggle').removeClass('disabled');

    $('#' + loadingElementTargetId).hide();

    $('#' + updateElementId).removeClass("ajax-overlay");

    var formUpdateTarget = $('#' + updateElementId);

    $(formUpdateTarget).html(data.view);

    //refresh sticky elements which will otherwise bleed into other components due to the DOM shift
    Sticky.update();

    var jsonData = JSON.parse(data.json);

    //update filters
    var filtersContainerElement = $('.find-a-provider-filter-container');

    var filtersContainerElementChildrenToUpdate = $(filtersContainerElement).find('[data-form-update-children]');

    //input groups
    filtersContainerElementChildrenToUpdate.each(function (index, element) {
        //get the template
        var itemTemplate = $(element).attr('data-form-update-children-template');
        //get the checked values based on the query string
        var inputName = $(element).attr('data-form-update-children-name');
        var checkedValues = getParams()[inputName];
        //get the wrapping element (parent with input + label)
        var facetElementContainers = $(element).find('input').parent();
        //get the parent element where the items will be inserted
        var facetElementWrappingContainer = $(element);

        var clearChildren = $(element)[0].hasAttribute('data-form-update-children-clear');

        //remove the old elements
        if (clearChildren) {
            facetElementContainers.remove();
        }

        var propertyToFind = $(element).attr('data-form-update-children');
        //get the facet
        var facet = getArrayItemByPropertyValue(jsonData.facets ?? jsonData._facets, "field", propertyToFind);

        var dropdownSearch = $(element).closest('.dropdown-container').find('input.dropdown-search');

        //generate an item per terms
        if (facet.terms && facet.terms.length) {

            if (dropdownSearch && dropdownSearch.length) {
                $(dropdownSearch).attr('placeholder', $(dropdownSearch).attr('data-original-placeholder'));
            }

            //loop through the available options, replacing the current list
            if (clearChildren) {
                facet.terms.forEach(function (term, index) {

                    var newFacetElement = $(itemTemplate).clone();
                    newFacetElement.removeClass('template');

                    var input = $(newFacetElement).find('input');
                    input.val(term.value);
                    input.attr('id', inputName + '-option-' + term.value.toLowerCase().replace(/ /g, "-"));
                    input.attr('name', inputName);

                    if (checkedValues) {

                        if (Array.isArray(checkedValues)) {
                            checkedValues.forEach(function (checkedValue, index) {
                                if (checkedValue == term.value) {
                                    input.attr('checked', true);
                                }
                            });
                        }
                        else if (checkedValues == term.value) {
                            input.attr('checked', true);
                        }
                    }

                    var label = $(newFacetElement).find('label');
                    label.attr('for', $(input).attr('id'));
                    $(label)[0].childNodes[0].nodeValue = term.value;
                    var facetCountSpan = $(label).find('span.facet');
                    facetCountSpan.text(' (' + term.count + ')');

                    newFacetElement.appendTo(facetElementWrappingContainer);
                });
            }
            //loop through the available options, disable any with no results
            // NOTE: this condition is currently not in use and should not be used, see TODO below
            else if ($(element)[0].hasAttribute('data-form-update-children-disable')) {

                $(facetElementContainers).each(function () {

                    //TODO: if the element itself was the last changed thing, skip this process, as in the case with gender in which the option itself does not negate its own options when changed

                    var input = $(element).find('input');
                    var inputValue = input.val(); //get the current input selection

                    //loop through every child element, determine if their value matches on of the resulting facets, otherwise disable it
                    $(input).each(function (key, individualInput) {

                        var individualInputVal = $(individualInput).val();

                        if (individualInputVal === '') {
                            return true;
                        }

                        $(individualInput).attr('disabled', 'disabled');

                        for (let i = 0; i < facet.terms.length; i++) {

                            var subfacet = getArrayItemByPropertyValue(facet.terms, "value", individualInputVal);

                            if (subfacet && subfacet.count > 0) {
                                $(individualInput).removeAttr('disabled');
                                break;
                            }
                        }
                    });
                });
            }
            //loop through the available options, updating the available options
            else {
                $(facetElementContainers).each(function () {
                    var inputs = $(element).find('.filter-group-option');

                    inputs.each(function () {
                        var input = $(this).find('input');

                        var subfacet = getArrayItemByPropertyValue(facet.terms, "value", $(input).val());

                        var count = 0;

                        if (subfacet) {
                            count = subfacet.count;
                        }

                        var label = $(this).find('label');
                        var facetCountSpan = $(label).find('span.facet');
                        facetCountSpan.text(' (' + count + ')');
                    });
                });
            }
        }
        else {
            if (dropdownSearch && dropdownSearch.length) {
                console.debug("disabling dropdown");
                $(element).closest('.dropdown-container').find('.dropdown-toggle').addClass('disabled');
                $(dropdownSearch).attr('disabled', '');
                $(dropdownSearch).attr('placeholder', 'No results found');
            }
        }


        var locationTypeInputElementSelector = 'input[name=location_type]';

        var showPreview = true;

        if ($(locationTypeInputElementSelector + ':checked').length === $(locationTypeInputElementSelector).length
        ) {
            const urlParams = new URLSearchParams(location.search);
            //check if query string contains any other value except location type and page
            for (const [key, value] of urlParams) {
                if (key != 'location_type' && key != 'page') {
                    if (value) {
                        showPreview = false;
                        break;
                    }
                }
            }
        }
        else {
            showPreview = false;
        }

        if (showPreview) {
            $(form).find('.preview').show();
            $(form).find('.results').hide();
        }
        else {
            $(form).find('.preview').hide();
            $(form).find('.results').show();
        }


    });

    //update any individually marked elements
    //note that this intentionally happens after the children function, in rare cases where we need to override a result from there (such as a "no preference" option that isn't available via kyruus)
    $(filtersContainerElement).find('[data-form-update-facet]').each(function (elem) {

        var propertyToFind = $(this).attr('data-form-update-facet');
        var termToFind = $(this).attr('data-form-update-term');
        var facetElement = $(this);

        var facet = getArrayItemByPropertyValue(jsonData.facets, "field", propertyToFind);

        if (facet) {
            if (termToFind) {
                var term = getArrayItemByPropertyValue(facet.terms, "value", termToFind);
                if (term) {
                    $(facetElement).html("(" + term.count + ")");
                }
            }
            else {
                $(facetElement).html("(" + facet.total + ")");
            }
        }
    });
}

//this is an extended version of the base mvc functionality that re-enables inputs
window.MVCAjaxFormOnFailure = function (formId, data, status, xhr) {

    var form = $('#' + formId);
    var updateElementId = $(form).attr('data-ajax-custom-update-element');
    var loadingElementTargetId = $(form).attr('data-ajax-custom-loading-element');

    $(form).find(':input').removeAttr('disabled');

    $('#' + loadingElementTargetId).hide();

    $('#' + updateElementId).removeClass("ajax-overlay");

    var formUpdateTarget = $('#' + updateElementId);

    $(formUpdateTarget).html("There was an error, please try again later.");
}

function getArrayItemByPropertyValue(array, propertyName, propertyValue) {
    var arrayItem = array.find(function (item) {
        if (item[propertyName] === propertyValue) {
            return item;
        }
    });

    return arrayItem;
}

//extended version of builtin search params to correctly yield when there are multiple identical keys
function getParams(url = window.location) {

    // Create a params object
    let params = {};

    new URL(url).searchParams.forEach(function (val, key) {
        if (params[key] !== undefined) {
            if (!Array.isArray(params[key])) {
                params[key] = [params[key]];
            }
            params[key].push(val);
        } else {
            params[key] = val;
        }
    });

    return params;

}

//intentionally positioned at the bottom to bind and therefore execute last
$('[data-form-submit-trigger]').click(function () {
    $(this).closest("form").submit();
});

$(document).on('click', '[data-input-mask-close]', function () {
    var maskElement = $(this).closest('[data-input-mask]');
    var inputElement = $('#' + $(maskElement).attr('data-input-mask'));
    $(maskElement).hide();
    $(inputElement).removeAttr('readonly');
    $(inputElement).removeClass('masked-input');
    $(inputElement).val('');
    $(inputElement).closest('form').submit();
    $('[data-geolocation-trigger]').show();
});

//smooth scroll the user to the targeted element on submit
$("form[data-form-submit-anchor]").submit(function (e) {

    //if ($(this).attr('data-form-submit-anchor')) {
    //    $('html, body').animate({
    //        scrollTop: $('#' + $(this).attr('data-form-submit-anchor')).offset().top
    //    }, 100);
    //}

    if ($(this).attr('data-form-submit-anchor')) {

        var target;

        if ($(this).attr('data-form-submit-anchor').startsWith("#")) {
            target = $($(this).attr('data-form-submit-anchor'));
        }
        else {
            target = $('#' + $(this).attr('data-form-submit-anchor'));
        }

        // Does a scroll target exist?
        if (target.length) {

            //pre calculated offset
            var headerOffset = parseInt(target.css("scroll-margin-top"), 10);
            var targetOffset = target.offset().top;
            var calculatedOffset = targetOffset - headerOffset;

            //compensating for unknown pixel offset
            calculatedOffset = calculatedOffset + 1;

            // Only prevent default if animation is actually gonna happen
            e.preventDefault();
            $('html, body').animate({
                scrollTop: calculatedOffset
            }, 0, function () {
                // Callback after animation 
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                    return false;
                } else {
                    $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                };
            });
        }
    }
});

function setMobileInputPlaceholders(inputs) {

    var screenSize = currentBSSize();

    var desktopPlaceholderAttribute = 'data-input-desktop-placeholder';
    var mobilePlaceholderAttribute = 'data-input-mobile-placeholder';

    if (screenSize === 'lg' || screenSize === 'xl') {
        $(inputs).each(function () {

            if ($(this).attr(desktopPlaceholderAttribute)) {
                $(this).attr('placeholder', $(this).attr(desktopPlaceholderAttribute));
            }
        });
    }
    else {
        $(inputs).each(function () {
            if ($(this).attr(mobilePlaceholderAttribute)) {
                $(this).attr('placeholder', $(this).attr(mobilePlaceholderAttribute));
            }
        });
    }
}

$(document).ready(function () {

    var inputs = $(document).find('[data-input-mobile-placeholder][data-input-desktop-placeholder]');

    if (inputs.length > 0) {
        setMobileInputPlaceholders(inputs);

        $(window).on('resize', throttle(function () {
            setMobileInputPlaceholders(inputs);
        }, 400));
    }

    resetMovedElements();

    $(window).on('resize', throttle(function () {
        resetMovedElements();
    }, 400));
});

$(document).ready(function () {
    linkFormstackFormTermsAndConditions();
});

function linkFormstackFormTermsAndConditions() {
    $('.formstack-form').each(function () {
        var linkTemplate = $(this).find('.formstack-tc-link');
        if (linkTemplate.length) {
            var form = $(this).find('.formstack-form-form');
            var labels = $(form).find('label');

            $(labels).each(function () {
                $(this).html($(this).html().replace(/Terms and Conditions/ig, $(linkTemplate)[0].innerHTML));
            });
        }
    });
}

$('[data-trigger-click]').on('click', function (e) {
    e.preventDefault();

    var target = $(this).attr('data-trigger-click');

    var targetElement = $(target);

    if ($(targetElement).length) {
        $(targetElement).trigger('click');
    }
});

$('[data-single-checkbox-select]').on('click', function (e) {
    var target = $(this).attr('data-single-checkbox-select');

    var targetElement = $(target);

    if ($(targetElement).length) {
        var targetElementCheckboxes = $('input[name=' + $(targetElement).attr('name') + ']').not(targetElement);
        $(targetElementCheckboxes).prop("checked", false);
        $(targetElement).prop("checked", true);
        $(targetElement).closest('form').submit();
    }
});

function moveElement(element, parent) {
    $(element).detach();
    $(parent).append(element);
}

$('[data-click-move-element]').on('click', function (e) {
    var source = $($(this).attr('data-move-element-from'));
    var destination = $($(this).attr('data-move-element-to'));

    if (source.length && destination.length) {
        moveElement(source, destination);
    }
});

function resetMovedElements() {

    var screenSize = currentBSSize();

    var desktopPlaceholderAttribute = 'data-desktop-parent-element';

    $('[' + desktopPlaceholderAttribute + ']').each(function () {

        var source = $(this);
        var destinationSelector = $(this).attr(desktopPlaceholderAttribute);
        var destination = $(destinationSelector);

        if (source.length && !source.parent().is(destination)) {
            if (screenSize === 'lg' || screenSize === 'xl') {
                moveElement(source, destination);
                source.removeAttr('style');
            }
        }
    });
}

//note that "change" will trigger on type inputs on tab out
$('.formstack-form-form :input').on('change', function () {
    evaluateFormstackLogic($(this).closest('form'));
    evaluateFormstackSubmitDisplay($(this).closest('form'));
});

//this is not a one-size fits all solution. formstack does not allow us to uniquely attribute fields, so we cann specify what constitutes the display in all cases. presently the assumption is that if only a single non logic field is present and the rest are hidden, to hide the submit button 
function evaluateFormstackSubmitDisplay(form) {
    //is there more than one non logic enabled input?
    var formInputs = $(form).find('[data-form-field-logic=""] :input:not([type=hidden])');
    var submitButton = $(form).find('[data-formstack-submit]');

    //skip if so
    if (formInputs.length > 1) {
        submitButton.removeAttr('disabled');
        submitButton.show();
        return;
    }

    //get the logic enabled fields
    var logicFormInputs = $(form).find('[data-form-field-logic!=""][data-form-field-logic]');

    //if there are no logical fields, do nothing
    if (logicFormInputs.length === 0) {
        submitButton.removeAttr('disabled');
        submitButton.show();
        return;
    }

    //get the visible logic enabled fields
    var visibleLogFormInputs = $(logicFormInputs).find(':visible :input:not([type=hidden])');

    //if at least one or more logic enabled inputs are being displayed, show submit button
    if (visibleLogFormInputs.length > 1) {
        submitButton.removeAttr('disabled');
        submitButton.show();
    }
    else {
        submitButton.attr('disabled', true);
        submitButton.hide();
    }
}

function evaluateFormstackLogic(form) {

    var formLogicFields = $(form).find('[data-form-field-logic!=""][data-form-field-logic]');

    //note that this logic should align with Formstack Form.cshtml
    $(formLogicFields).each(function () {
        var logicJSONString = $(this).attr('data-form-field-logic');
        var logic = JSON.parse(logicJSONString);

        var showField = true;

        $.each(logic.checks, function (i, check) {
            //find the field by name, because checkboxes and radios will have a different ID
            var formStackFormFieldToCheck = $('[name=field_' + check.field + ']');

            showField = logic.action == "show" ? false : true;

            if (formStackFormFieldToCheck != null && formStackFormFieldToCheck.length) {

                var isSelected = $(formStackFormFieldToCheck).val() == check.option;

                if (isSelected && ($(formStackFormFieldToCheck).is('[type=checkbox]')) || $(formStackFormFieldToCheck).is('[type=radio]')) {
                    isSelected = $(formStackFormFieldToCheck).is(':checked');
                }

                if (isSelected) {

                    //if its an all, continue to the next evaluator
                    if (logic.conditional == "all") {
                        if (logic.action == "show") {
                            showField = true;
                        }
                        else {
                            showField = false;
                        }
                    }
                    //if its an any, mark and break
                    else {
                        if (logic.action == "show") {
                            showField = true;
                        }
                        else {
                            showField = false;
                        }

                        return false;
                    }
                }
                else {
                    if (logic.action == "show") {
                        showField = false;
                    }
                    else {
                        showField = true;
                    }

                    //if its an all, break
                    if (logic.conditional == "all") {
                        return false;
                    }
                }
            }
        });

        var hiddenClass = "formstack-logic-hidden";

        if (showField) {
            $(this).removeClass(hiddenClass);
        }
        else if (!$(this).hasClass(hiddenClass)) {
            $(this).addClass(hiddenClass);
        }
    });
}